import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../app/services/account.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-anonymous',
  templateUrl: './anonymous.component.html',
  styleUrls: ['./anonymous.component.scss'],
})
export class AnonymousComponent implements OnInit {
  login;
  ipoLogin;
  currentUser;
  constructor(private accountService: AccountService, private router: Router) {
    this.accountService.getLoginSuccess.subscribe(async (status) => {
      this.login = localStorage['atk'] ? true : false;
    });
  }

  async ngOnInit() {
    this.login = localStorage['atk'] ? true : false;
    this.ipoLogin = this.router.url.indexOf('ipo') > -1 || this.router.url.indexOf('debenture-issue') > -1 ? true : false;
  }
  refreshIPO() {
    this.accountService.emitLoginStatus(false);
  }
  async logout() {
    try {
      this.currentUser = await this.accountService.currentUserAsync();
      await this.accountService.signOut();
      if (this.router.url.indexOf('ipo') > -1 || this.router.url.indexOf('debenture-issue') > -1) {
        // console.log(this.router.url);
        window.location.reload();
        // localStorage.clear();
        // this.accountService.emitLoginStatus(false);
      } else if (this.currentUser.roles.some((role) => role === 'ROLE_ADMIN')) {
        this.router.navigate(['/admin-login']);
      } else {
        this.router.navigate(['/signin']);
      }
    } catch (e) {
      localStorage.clear();
    }
    localStorage.clear();
    this.login = false;
  }
}
